export default __webpack_public_path__ + "static/media/xrp.5ee29933.svg";